import type { FC } from "react";

type FormComponentTitleProps = {
  title: string;
  subTitle: string;
};

const FormComponentTitle: FC<FormComponentTitleProps> = ({
  title,
  subTitle,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="font-semibold text-gray-950 text-lg">{title}</div>
      <div className="text-gray-600 text-sm">{subTitle}</div>
    </div>
  );
};

export default FormComponentTitle;
